module.exports = __webpack_public_path__ + "static/media/finity_logo_white_moneycontrol.f2133ef3.svg";